import React from 'react';
import { Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-52">
      <div className="text-center mb-12" data-id="element-53">
        <h2 className="text-3xl md:text-4xl font-bold text-[#F5F0EB] mb-6" data-id="element-54">
          He creado{' '}
          <span className="text-[#C5A55A] italic" data-id="element-55">"El Método del Látex"</span>
        </h2>
        <p className="text-xl text-[#A89B8C] leading-relaxed" data-id="element-56">
          Para ser el puente entre tu miedo y tu primera clienta paga. No es un
          curso de videos infinitos. Es un plan de entrenamiento militar para
          tus manos.
        </p>
      </div>

      {/* Product Image */}
      <div className="flex justify-center mb-16" data-id="element-57">
        <div className="relative max-w-sm w-full" data-id="element-58">
          <div className="absolute inset-0 bg-[#C5A55A]/8 rounded-3xl blur-3xl scale-90 -z-10" data-id="element-59"></div>
          <img src="https://cdn.magicpatterns.com/uploads/4yWkERiCFcPRMRm1YaT8Rb/Gemini_Generated_Image_bmpjxbmpjxbmpjxb.png" alt="El Método del Látex — Ebook y láminas de práctica de microblading" className="w-full h-auto rounded-2xl shadow-2xl shadow-black/30" data-id="element-60" />
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-61">
        {[{
        title: 'La Regla de la Moneda',
        desc: 'Cómo saber la profundidad exacta sin tocar piel humana.'
      }, {
        title: 'Entrenamiento de 21 Días',
        desc: 'Ejercicios diarios de 20 minutos para que tu mano no vuelva a temblar.'
      }, {
        title: 'Autocorrección Pro',
        desc: 'Cómo ser tu propia maestra y detectar errores antes de que sean permanentes.'
      }].map((item, idx) => <div key={idx} className="bg-[#2A2520] p-6 rounded-xl shadow-sm border border-[#3A3330] hover:border-[#C5A55A]/30 transition-colors" data-id="element-62">
            <div className="w-10 h-10 bg-[#C5A55A]/10 rounded-full flex items-center justify-center mb-4 text-[#C5A55A]" data-id="element-63">
              <Star className="w-5 h-5 fill-current" data-id="element-64" />
            </div>
            <h3 className="font-bold text-lg text-[#F5F0EB] mb-2 font-serif" data-id="element-65">
              {item.title}
            </h3>
            <p className="text-[#A89B8C] text-sm leading-relaxed" data-id="element-66">
              {item.desc}
            </p>
          </div>)}
      </div>

      <div className="bg-[#2A2520] text-[#F5F0EB] p-8 md:p-12 rounded-2xl text-center relative overflow-hidden border border-[#3A3330]" data-id="element-67">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-68">
          <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%] bg-[radial-gradient(circle,rgba(197,165,90,0.3)_0%,transparent_60%)]" data-id="element-69"></div>
        </div>

        <div className="relative z-10" data-id="element-70">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 font-serif text-[#F5F0EB]" data-id="element-71">
            No necesitas otra certificación de $1.200.000 ARS.
          </h3>
          <p className="text-lg text-[#A89B8C] mb-4 max-w-xl mx-auto" data-id="element-72">
            Necesitas que tus manos sepan qué hacer. Recupera tu confianza y tu
            inversión hoy mismo.
          </p>

          {/* Pricing */}
          <div className="mb-8" data-id="element-73">
            <span className="inline-block bg-[#C5A55A] text-[#1E1B19] text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-4" data-id="element-74">
              50% OFF
            </span>
            <div className="flex items-center justify-center gap-3" data-id="element-75">
              <span className="text-[#7A6F64] line-through text-lg" data-id="element-76">
                $14.310 ARS
              </span>
              <span className="text-4xl md:text-5xl font-bold text-[#C5A55A] font-serif" data-id="element-77">
                $9.540{' '}
                <span className="text-lg font-sans font-normal text-[#A89B8C]" data-id="element-78">
                  ARS
                </span>
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-79">
            <CTAButton className="text-xl px-10 py-5" data-id="element-80">
              QUIERO PERDER EL MIEDO POR $9.540
            </CTAButton>
            <p className="text-xs text-[#7A6F64] mt-2 uppercase tracking-widest" data-id="element-81">
              Acceso Inmediato • Garantía de 30 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}